import { render, staticRenderFns } from "./FaqAccordion.vue?vue&type=template&id=256344a2&scoped=true&"
import script from "./FaqAccordion.vue?vue&type=script&lang=js&"
export * from "./FaqAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FaqAccordion.vue?vue&type=style&index=0&id=256344a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256344a2",
  null
  
)

export default component.exports